import { render, staticRenderFns } from "./Areas.vue?vue&type=template&id=8f4d0238&scoped=true"
import script from "./Areas.vue?vue&type=script&lang=js"
export * from "./Areas.vue?vue&type=script&lang=js"
import "./Areas.vue?vue&type=style&index=0&id=8f4d0238&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4d0238",
  null
  
)

export default component.exports